import { Loader } from "@googlemaps/js-api-loader"

const Map = () => {
  const mapRef = document.querySelector('.js-google-map');

  if (mapRef) {
    const loader = new Loader({
      apiKey: process.env.MIX_GOOGLE_MAPS_API
    });

    const center = {
      lat: parseFloat(mapRef.dataset.lat),
      lng: parseFloat(mapRef.dataset.lng),
    };

    loader.load().then(async () => {
      const { Map } = await google.maps.importLibrary("maps");
      const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

      const map = new Map(mapRef, {
        center: center,
        zoom: 12,
        mapId: 'Project_Map',
        disableDefaultUI: true
      });

      const marker = new AdvancedMarkerElement({
        map,
        position: center,
        title: 'City Properties Office'
      });
    })
  }
}

export default Map;
